"use client"
import CommonTitle from "@/ui/common/bit/CommonTitle"
import { mediaQueries } from "@/ui/theme/mediaQueries"
import { sizes } from "@/ui/theme/sizes"
import styled from "@emotion/styled"
import BlockWrapper from "../../common/BlockWrapper"

export const StyledBlockWrapper = styled(BlockWrapper)`
  max-width: unset;
  ${mediaQueries.mobile} {
    padding-top: 70px;
    margin-top: -15px;
  }
  ${mediaQueries.tablet} {
    padding-top: 90px;
    margin-top: -15px;
  }
  ${mediaQueries.desktopM} {
    padding: 60px ${sizes.baseDouble};
    margin-top: -60px;
    padding-top: 120px;
  }
`

export const StyledMiddleCommonTitle = styled(CommonTitle)`
  align-items: center;
  width: 100%;
`
